import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";
import {
  payloadParentHistoryList,
  payloadParentOptions,
  payloadUpdateParent,
  payloadUpdateParentHistoryRow,
} from "../../store/admin/subAffParent";

const updateParent = (data: payloadUpdateParent) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.sub_aff_parent.update;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getParentOptions = (data: payloadParentOptions) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.sub_aff_parent.options_master_affiliates;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getHistory = (data: payloadParentHistoryList) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.sub_aff_parent.history;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const updateHistoryRow = (data: payloadUpdateParentHistoryRow) => {
  const authenticity_token = getCookie(cookieToken);

  const { id, ...body } = data;

  const endpoint = api.admin.sub_aff_parent.update_history.replace('{hierarchyChangeId}', `${id}`);

  const payload = {
    ...body,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('PATCH', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const deleteHistoryRow = (data: { id: number | string }) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.sub_aff_parent.delete_history.replace('{hierarchyChangeId}', `${data.id}`);

  const payload = {
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('DELETE', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

export const subAffParentService = {
  updateParent,
  getParentOptions,
  getHistory,
  updateHistoryRow,
  deleteHistoryRow,
};
